class Menu {
	constructor() {
		this.navMain = document.querySelector('.nav-main');
		this.openBtn = document.querySelector('.mobile-menu-btn');
		this.closeBtn = document.querySelector('.close-btn');
		this.headerMain = document.querySelector('.header-main');

		this.bindEvents();
		this.menuOnScroll();
		this.getChildrenMenu();
	}


	menuOnScroll() {
		let mm = gsap.matchMedia();

		mm.add('(min-width: 1024px)', () => {
			ScrollTrigger.create({
				trigger: this.headerMain,
				start: this.headerMain.offsetHeight,
				end: 99999,
				toggleClass: {
					targets: this.headerMain,
					className: "header-main--scrolled"
				},
			});

			Observer.create({
				type: "scroll",
				tolerance: 30,
				dragMinimum: 30,
				onUp: () => {
					this.headerMain.classList.remove("hide-on-top");
				},
				onDown: () => {
					this.headerMain.classList.add("hide-on-top");
				}
			});
		});
	}

	openMenu() {
		this.navMain.classList.add('open');
	}

	closeMenu() {
		this.navMain.classList.remove('open');
	}

	bindEvents() {
		this.openBtn.addEventListener('click', this.openMenu.bind(this));
		this.closeBtn.addEventListener('click', this.closeMenu.bind(this));
	}

	getChildrenMenu() {
		let mm = gsap.matchMedia();
		let childrenMenu = document.querySelectorAll('.menu-item-has-children');

		if (childrenMenu.length > 0) {

			mm.add('(min-width: 1024px)', () => {

				childrenMenu.forEach(child => {

					const subMenu = child.querySelector('ul');
					const subMenuItems = subMenu.querySelectorAll('li');

					const tl = gsap.timeline();

						//
						// 	child.addEventListener('click', (e) => {
						// 		e.preventDefault();
						// 		console.log('click');
						// 		subMenu.classList.add('active');
						// 	});
						//
						//
						// } else {
						gsap.set(subMenu, {
							y: -10,
							x: '-50%',
							autoAlpha: 0,
						});
						//
						// gsap.set(subMenuItems, {
						// 	y: 10,
						// 	autoAlpha: 0,
						// });

						tl.to(subMenu, {y: 0, autoAlpha: 1, duration: 0.1, ease: "none"})
							.to(subMenuItems, {y: 0, autoAlpha: 1, duration: 0.1, ease: "none", stagger: 0.05}, 0.05);

						tl.pause();

						child.addEventListener('mouseenter', (e) => {
							e.preventDefault();
							tl.play();
						});

						child.addEventListener('mouseleave', (e) => {
							e.preventDefault();
							tl.reverse();
						});


				});
			});

		}
	}
}
